import React from 'react'
import PropTypes from 'prop-types'
import HoldingsListRow from './HoldingsListRow'

import styles from './HoldingsList.module.scss'

const HoldingsList = (props) => {
  const {
    holdings,
    isMobile,
  } = props

  const getAssetClassHoldings = (className, classHoldings) => (
    classHoldings.map((holding, i) => (
      <HoldingsListRow
        key={i}
        isMobile={isMobile}
        assetName={holding.assetName}
        percentage={holding.percentage}
        classAllocationName={className}
        marketValue={holding.marketValue} />)
    )
  )

  const getAllHoldings = holdings => (
    holdings.map((assetClassBlock, i) => {
      const {
        className,
        classHoldings,
        totalMarketValue,
      } = assetClassBlock

      return (
        <React.Fragment key={i}>
          <HoldingsListRow
            classAllocationName={className}
            marketValue={totalMarketValue}
            isMobile={isMobile}
            isHeaderRow={true}
            isFirstHeader={i === 0} />
          <div className={styles.divider} />
          <div className={styles.classGroup}>
            {getAssetClassHoldings(className, classHoldings)}
            <HoldingsListRow
              isFooterRow={true}
              marketValue={totalMarketValue}
              isMobile={isMobile} />
          </div>
        </React.Fragment>
      )
    })
  )

  return (
    <div className={styles.HoldingsList} data-test-id="holdingsSummary-testId">
      <div className={styles.holdingsContainer}>
        <p className={styles.title}>Holdings</p>
        { getAllHoldings(holdings) }
      </div>
    </div>
  )
}

HoldingsList.defaultProps = {
  holdings: [],
  isMobile: false,
}

HoldingsList.propTypes = {
  holdings: PropTypes.array,
  isMobile: PropTypes.bool,
}

export default HoldingsList



// WEBPACK FOOTER //
// ./src/components/Client/HoldingsList/HoldingsList.jsx